import { getModalByTemplate } from "../modal";

export function newsletterCampolab() {
    const formNewsletter = document.getElementById("form-newsletter-campolab");
    const buttonSubmit = formNewsletter.querySelector("[type=submit]")

    console.log(formNewsletter);
    formNewsletter.addEventListener("submit", function (e) {
        e.preventDefault()

        buttonSubmit.classList.add("disabled", "loading")
        var CRAFT_CSRF_NAME = window.csrfTokenName;
        var CRAFT_CSRF_TOKEN = window.csrfTokenValue;

        let formData = new FormData()
        formData.append(CRAFT_CSRF_NAME, CRAFT_CSRF_TOKEN);
        formData.append('newsletter-email', document.querySelector('#newsletter-campolab-email').value)
        formData.append('newsletter-nome', document.querySelector('#newsletter-campolab-nome').value)

        fetch('/actions/general-module/newsletter/cadastro-newsletter-campolab', {
            method: "POST",
            body: formData,
        }).then((response) => {
            return response.json();
        }).then((json) => {
            if (json.success) {
                document.querySelectorAll("#form-newsletter-campolab fieldset").forEach(function (el) {
                    el.classList.add("disabled")
                })

                buttonSubmit.classList.remove("loading")
                buttonSubmit.innerHTML = "Enviado com sucesso!"

                getModalByTemplate("newsletter-sent");
            } else {
                buttonSubmit.classList.remove("disabled", "loading")

                getModalByTemplate("generic-error", {
                    title: "Não foi possível realizar o seu cadastro",
                    description: json.message,
                });
            }
        })
    })
}

if (document.getElementById("form-newsletter-campolab")) {
    newsletterCampolab()
}
